<template>
  <!-- 销售数据 -->
  <div>
    <div class="mtd-and-ytd">
      <!-- MTD -->
      <div class="container data-chart">
        <div class="selfheader">
          <div style="font-size: 14px">MTD</div>
          <el-popover
            placement="top"
            width="200"
            popper-class="followuppopover"
            trigger="hover"
          >
            <p class="tipck">
              MTD：当月累计数据；<br />
              仅支持查看2023年6月份后数据
            </p>
            <div class="question" slot="reference">
              <div>?</div>
            </div>
          </el-popover>
        </div>
        <div class="datas" v-for="(item, index) in mtd" :key="index">
          <div class="title">
            <p>
              {{ item.title }}
            </p>
            <el-popover
              placement="top"
              width="260"
              popper-class="followuppopover"
              trigger="hover"
            >
              <div class="tipck" v-if="item.n === 1">
                <p>{{ item.popover1 }}</p>
                <p>{{ item.popover2 }}</p>
              </div>
              <div class="tipck" v-if="item.n === 2">
                <p>{{ item.popover3 }}</p>
                <p>{{ item.popover10 }}</p>
                <p>{{ item.popover11 }}</p>
                <p>{{ item.popover4 }}</p>
                <p>{{ item.popover5 }}</p>
                <p>{{ item.popover6 }}</p>
                <p>{{ item.popover7 }}</p>
              </div>
              <div class="tipck" v-if="item.n === 3">
                <p>{{ item.popover8 }}</p>
                <p>{{ item.popover9 }}</p>
                <p>{{ item.popover10 }}</p>
              </div>
              <div class="question" slot="reference">
                <div>?</div>
              </div>
            </el-popover>
          </div>
          <div class="data-item">
            <div
              :class="it.route_name !== '' ? 'item high-light' : 'item'"
              v-for="(it, ind) in item.arr"
              :key="ind"
              @click="goTetail(it.route_name, it.key)"
            >
              <div class="item-top">
                <p>{{ it.name }}</p>
              </div>
              <div class="item-bottom">{{ it.num }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- YTD -->
      <div class="container data-chart">
        <div class="selfheader">
          <div style="font-size: 14px">YTD</div>
          <el-popover
            placement="top"
            width="200"
            popper-class="followuppopover"
            trigger="hover"
          >
            <p class="tipck">
              YTD：今年累计数据；<br />
              仅支持查看2023年6月份后数据
            </p>
            <div class="question" slot="reference">
              <div>?</div>
            </div>
          </el-popover>
        </div>
        <div class="datas" v-for="(item, index) in ytd" :key="index">
          <div class="title">
            <p>
              {{ item.title }}
            </p>
            <el-popover
              placement="top"
              width="260"
              popper-class="followuppopover"
              trigger="hover"
            >
              <div class="tipck" v-if="item.n === 1">
                <p>{{ item.popover1 }}</p>
                <p>{{ item.popover2 }}</p>
              </div>
              <div class="tipck" v-if="item.n === 2">
                <p>{{ item.popover3 }}</p>
                <p>{{ item.popover10 }}</p>
                <p>{{ item.popover11 }}</p>
                <p>{{ item.popover4 }}</p>
                <p>{{ item.popover5 }}</p>
                <p>{{ item.popover6 }}</p>
                <p>{{ item.popover7 }}</p>
              </div>
              <div class="tipck" v-if="item.n === 3">
                <p>{{ item.popover8 }}</p>
                <p>{{ item.popover9 }}</p>
                <p>{{ item.popover10 }}</p>
              </div>
              <div class="question" slot="reference">
                <div>?</div>
              </div>
            </el-popover>
          </div>
          <div class="data-item">
            <div class="item" v-for="(it, ind) in item.arr" :key="ind">
              <div class="item-top">
                <p>{{ it.name }}</p>
              </div>
              <div class="item-bottom">{{ it.num }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 数据明细 -->
    <div class="container" style="margin-top: 12px">
      <div class="cont-form">
        <el-form :model="searchInfo" label-width="80px" inline size="mini">
          <div style="font-size: 14px; display: inline-block; margin-top: 7px">
            数据明细
          </div>
          <el-form-item label="查询时间">
            <el-date-picker
              v-model="searchInfo.mouthTime"
              type="monthrange"
              range-separator="至"
              start-placeholder="开始月份"
              value-format="yyyy-MM"
              end-placeholder="结束月份"
              @change="handleSearch"
              :clearable="false"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchInfo.region"
              placeholder="高级筛选"
              clearable
              @change="handleSearch"
            >
              <el-option label="课程顾问" :value="1"></el-option>
              <el-option label="出现方式" :value="2"></el-option>
              <el-option label="来源渠道" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="staff_id" v-show="searchInfo.region === 1">
            <common-staff-pull-down
              :originId.sync="searchInfo.staff_id"
              :jobIds="[3]"
              @change="handleSearch"
            ></common-staff-pull-down>
          </el-form-item>
          <el-form-item prop="studentApp_id" v-show="searchInfo.region === 2">
            <el-select
              v-model="searchInfo.studentApp_id"
              clearable
              placeholder="请选择"
              @change="handleSearch"
            >
              <el-option
                v-for="item in studentAppearList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="source_id" v-show="searchInfo.region === 4">
            <el-select
              v-model="searchInfo.source_id"
              clearable
              placeholder="请选择"
              @change="handleSearch"
            >
              <el-option
                v-for="item in sourceList"
                :key="item.source_id"
                :label="item.name"
                :value="item.source_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div style="min-height: 240px">
        <div class="tabs">
          <div
            :class="checkTabs === 1 ? 'tabs-in p1 check-tabs' : 'tabs-in p1 '"
            @click="checkTabs = 1"
          >
            综合数据
          </div>
          <div
            :class="checkTabs === 2 ? 'tabs-in check-tabs' : 'tabs-in '"
            @click="checkTabs = 2"
          >
            出现方式
          </div>
          <div
            :class="checkTabs === 3 ? 'tabs-in check-tabs' : 'tabs-in '"
            @click="checkTabs = 3"
          >
            来源渠道
          </div>
          <div
            :class="checkTabs === 4 ? 'tabs-in p2 check-tabs' : 'tabs-in p2'"
            @click="checkTabs = 4"
          >
            课程顾问
          </div>
        </div>
        <comprehensive-table
          v-if="checkTabs === 1"
          :data="searchData"
        ></comprehensive-table>
        <appear-table v-if="checkTabs === 2" :data="searchData"></appear-table>
        <channel-table
          v-if="checkTabs === 3"
          :data="searchData"
        ></channel-table>
        <course-table v-if="checkTabs === 4" :data="searchData"></course-table>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getStudentAppearListApi,
  sourceTypeSelectListApi,
} from "@/api/storeManagement";
import { salesHitherto } from "@/api/statistics";
import { dateFormat, getCurrentMonth } from "@/utils/timeFormat";
import comprehensiveTable from "./comprehensive.vue";
import appearTable from "./appear.vue";
import channelTable from "./channel.vue";
import courseTable from "./course.vue";
import { roundNumbers } from "@/utils/roundNumbers";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";

export default {
  components: {
    comprehensiveTable,
    appearTable,
    channelTable,
    courseTable,
    commonStaffPullDown,
  },
  data() {
    return {
      mtd: [],
      ytd: [],
      studentAppearList: [],
      sourceList: [],
      searchInfo: {
        mouthTime: [],
      },
      checkTabs: 1,
      start: "",
      end: "",
      searchData: {},
    };
  },
  created() {
    getStudentAppearListApi({
      page: 1,
      page_size: 500,
    }).then((res) => {
      if (res.error_code === 0) {
        this.studentAppearList = res.data.list;
      }
    });
    sourceTypeSelectListApi().then((res) => {
      if (res.error_code === 0) {
        this.sourceList = res.data.list;
      }
    });
    this.getMonthTime();
  },
  beforeMount() {
    salesHitherto().then((res) => {
      // console.log("salesHitherto", res);
      if (res.error_code === 0) {
        const studentArr = {
          title: "学员数据",
          popover1: "名单数：新录入的意向学员",
          popover2: "在读学员：查询时间最后一刻的在读学员数量",
          n: 1,
          arr: [
            {
              name: "名单数",
              num: res.data.mtd.roster_num,
              route_name: "",
              key: "",
            },
            {
              name: "在读学员",
              num: res.data.mtd.on_going_num,
              route_name: "",
              key: "",
            },
          ],
        };
        const stageArr = {
          title: "阶段数据",
          popover3: "跟进人数：录入了任意跟进记录的意向学员人数,按学员去重",
          popover10:
            "本月已联络：本月新增的意向学员,且在本月变更为已联络阶段,统计阶段表,按学员去重",
          popover4: "预约体验数：所有已预约体验的意向学员人数,按学员去重",
          popover11: "到访人数：录入了到访跟进记录的意向学员人数,按学员去重",
          popover5: "完成体验数：所有完成体验的意向学员人数,按学员去重",
          popover6: "新签学员数：所有完成新签的意向学员人数,按学员去重",
          popover7: "新签金额：所有意向学员的新签订单金额",
          n: 2,
          arr: [
            {
              name: "跟进人数", // 7期数据维度更改，只有已联络支持跳转
              num: res.data.mtd.connected_num,
              route_name: "",
              key: 1,
            },
            {
              name: "本月已联络",
              num: res.data.mtd.new_intention_connected_num,
              route_name: "",
              key: 1,
            },
            {
              name: "预约体验数",
              num: res.data.mtd.invited_count,
              route_name: "",
              key: 3,
            },
            {
              name: "到访人数",
              num: res.data.mtd.visited_num,
              route_name: "",
              key: "",
            },
            {
              name: "完成体验数",
              num: res.data.mtd.finish_count,
              route_name: "",
              key: 4,
            },
            {
              name: "新签学员数",
              num: res.data.mtd.transformed_num,
              route_name: "",
              key: 6,
            },
            {
              name: "新签金额",
              num: roundNumbers(res.data.mtd.order_amount),
              route_name: "",
              key: "",
            },
          ],
        };
        const transformArr = {
          title: "转化率",
          popover8: "名单体验率 = 完成体验数 / 名单总数 * 100%",
          popover9: "诺访体验率 = 完成体验数 / 预约体验数 * 100%",
          popover10: "体验转化率 = 新签学员数 / 完成体验数 * 100%",
          n: 3,
          arr: [
            {
              name: "名单体验率",
              num: roundNumbers(res.data.mtd.roster_experience_rate) + "%",
              route_name: "",
              key: "",
            },
            {
              name: "诺访体验率",
              num: roundNumbers(res.data.mtd.visit_experience_rate) + "%",
              route_name: "",
              key: "",
            },
            {
              name: "体验转化率",
              num: roundNumbers(res.data.mtd.experience_transform_rate) + "%",
              route_name: "",
              key: "",
            },
          ],
        };
        this.mtd.push(studentArr, stageArr, transformArr);
        const ytdStudentArr = {
          title: "学员数据",
          popover1: "名单数：新录入的意向学员",
          popover2: "在读学员：查询时间最后一刻的在读学员数量",
          n: 1,
          arr: [
            {
              name: "名单数",
              num: res.data.ytd.roster_num,
            },
            {
              name: "在读学员",
              num: res.data.ytd.on_going_num,
            },
          ],
        };
        const ytdStageArr = {
          title: "阶段数据",
          popover3: "跟进人数：录入了任意跟进记录的意向学员人数,按学员去重",
          popover10:
            "本年已联络：本年新增的意向学员,且在本年变更为已联络阶段,统计阶段表,按学员去重",
          popover4: "预约体验数：所有已预约体验的意向学员人数,按学员去重",
          popover11: "到访人数：录入了到访跟进记录的意向学员人数,按学员去重",
          popover5: "完成体验数：所有完成体验的意向学员人数,按学员去重",
          popover6: "新签学员数：所有完成新签的意向学员人数,按学员去重",
          popover7: "新签金额：所有意向学员的新签订单金额",
          n: 2,
          arr: [
            {
              name: "跟进人数",
              num: res.data.ytd.connected_num,
            },
            {
              name: "本年已联络",
              num: res.data.ytd.new_intention_connected_num,
            },
            {
              name: "预约体验数",
              num: res.data.ytd.invited_count,
            },
            {
              name: "到访人数",
              num: res.data.ytd.visited_num,
            },
            {
              name: "完成体验数",
              num: res.data.ytd.finish_count,
            },
            {
              name: "新签学员数",
              num: res.data.ytd.transformed_num,
            },
            {
              name: "新签金额",
              num: roundNumbers(res.data.ytd.order_amount),
            },
          ],
        };
        const ytdTransformArr = {
          title: "转化率",
          popover8: "名单体验率 = 完成体验数 / 名单总数 * 100%",
          popover9: "诺访体验率 = 完成体验数 / 预约体验数 * 100%",
          popover10: "体验转化率 = 新签学员数 / 完成体验数 * 100%",
          n: 3,
          arr: [
            {
              name: "名单体验率",
              num: roundNumbers(res.data.ytd.roster_experience_rate) + "%",
            },
            {
              name: "诺访体验率",
              num: roundNumbers(res.data.ytd.visit_experience_rate) + "%",
            },
            {
              name: "体验转化率",
              num: roundNumbers(res.data.ytd.experience_transform_rate) + "%",
            },
          ],
        };
        this.ytd.push(ytdStudentArr, ytdStageArr, ytdTransformArr);
      }
    });
  },
  methods: {
    handleSearch() {
      const monthStartArr = getCurrentMonth(this.searchInfo.mouthTime[0]);
      const monthEndArr = getCurrentMonth(this.searchInfo.mouthTime[1]);
      const start = dateFormat("YYYY-mm-dd", monthStartArr[0]);
      const end = dateFormat("YYYY-mm-dd", monthEndArr[1]);
      this.searchInfo.start_time = start;
      this.searchInfo.end_time = end;
      this.searchData = this.searchInfo;
      console.log("searchData", this.searchData);
    },
    getMonthTime() {
      const now = new Date();
      const monthArr = getCurrentMonth(now);
      this.start = dateFormat("YYYY-mm-dd", monthArr[0]);
      this.end = dateFormat("YYYY-mm-dd", monthArr[1]);
      this.searchInfo.mouthTime[0] = this.start.slice(0, 7);
      this.searchInfo.mouthTime[1] = this.end.slice(0, 7);
      this.handleSearch();
    },
    goTetail(val, key) {
      if (val !== "" && key !== "") {
        const detail = this.$router.resolve({
          name: val,
          query: {
            key: key,
            from: "salesData",
            s_time: this.start,
            e_time: this.end,
          },
        });
        window.open(detail.href, "_blank");
      }
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  overflow: hidden;
  color: #5c5d5e;
  .cont-form {
    margin-top: 20px;
  }
  .selfheader {
    padding-top: 14px;
    display: flex;
    align-items: center;
  }
  .datas {
    margin: 10px 0;
    .title {
      display: flex;
      align-items: center;
      font-size: 12px;
      margin-bottom: 10px;
      width: 100px;
    }
    .data-item {
      flex: 1;
      height: 55px;
      width: 100%;
      display: flex;
      .item {
        padding: 10px;
        text-align: center;
        box-sizing: border-box;
        width: 103px;
        background: #f6fafc;
        border-right: 1px solid #f1f2f2;
        &:last-child {
          border-right: none;
        }
        .item-top {
          margin-bottom: 5px;
          font-size: 12px;
        }
        .item-bottom {
          font-size: 18px;
          font-weight: 700;
        }
        &.high-light {
          cursor: pointer;
          &:hover {
            border: 1px solid #07d1aa !important;
            background: #f0fdfa !important;
          }
        }
      }
    }
  }
  .tabs {
    display: flex;
    margin-bottom: 15px;
    .tabs-in {
      border: 1px solid #c0c7ce;
      color: #5c5d5e;
      padding: 5px 15px;
      cursor: pointer;
      border-right: 0;
      &:last-child {
        border-right: 1px solid #c0c7ce;
      }
    }
    .p1 {
      border-radius: 3px 0 0 3px;
    }
    .p2 {
      border-radius: 0 3px 3px 0;
    }
  }
}
.mtd-and-ytd {
  display: flex;
  justify-content: space-between;
  align-items: start;
  .data-chart {
    width: 100%;
    // height: 309px;
    &:first-child {
      margin-right: 13px;
    }
  }
}
.check-tabs {
  border-color: #07d1aa !important;
  color: #07d1aa !important;
  & + .tabs-in {
    border-left: 1px solid #07d1aa !important;
  }
}
.question {
  width: 15px;
  height: 15px;
  opacity: 1;
  background: #bebfc0;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  line-height: 16px;
  font-size: 10px;
  margin-left: 5px;
}
</style>
